import _ from 'lodash';
import { getRequest } from '../../Common/network-call';
import { TABLE_URI_ADDON } from '../../../constants/constant';
import {
  FETCH_ORDERS,
  FIELDS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';

export const MY_BOOKED_NEWS = 'MY_BOOKED_NEWS';
export const FETCH_NEWS = 'FETCH_NEWS';
export const FETCH_NEWS_DETAILS = 'FETCH_NEWS_DETAILS';

export const fetchBookedNews = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(type=news)`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.bookmarks}?include_count=true&fields=${FIELDS.bookmarks.minInfo}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      response => {
        dispatch({
          type: MY_BOOKED_NEWS,
          payload: { resource: response.resource, count: response.meta.count }
        });
        callback({
          success: 1,
          resource: response.resource,
          count: response.meta.count
        });
      },
      error => {
        // callback({ success: 0, message: error });
      }
    );
  };
};

export const clearBookedNews = () => {
  return dispatch => {
    dispatch({
      type: MY_BOOKED_NEWS,
      payload: {}
    });
  };
};

export const fetchNews = (
  session,
  extra = { apptabId: null, sort: null },
  callback = null
) => {
  if (_.isNil(Number(extra?.apptabId)))
    return dispatch => (callback ? callback({ success: 0 }) : {});

  const fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(apptabid=${extra?.apptabId}))`
  );
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.news}?filter=${fetchFilter}&order=${FETCH_ORDERS.news}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      response => {
        const payload = {
          data: response.resource,
          count: response.resource.length
        };

        dispatch({
          type: FETCH_NEWS,
          payload
        });
        callback && callback({ success: 1, error: null, ...payload });
      },
      error => {
        callback && callback({ success: 0, error });
      }
    );
  };
};

export const setNewsDetails = payloadObj => {
  return dispatch =>
    dispatch({ type: FETCH_NEWS_DETAILS, payload: { data: payloadObj } });
};

export const fetchNewsDetails = (
  session,
  extra = { newsid: null, apptabId: null },
  callback
) => {
  let filter = encodeURI(
    `(newsid=${extra.newsid})AND(eventid=${session.eventid})AND(apptabid=${extra.apptabId})`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.news}?filter=${filter}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      response => {
        dispatch({
          type: FETCH_NEWS_DETAILS,
          payload: { data: response.resource, count: response.resource.length }
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const clearNewsDetails = () => {
  return dispatch => {
    dispatch({ type: FETCH_NEWS_DETAILS, payload: [] });
  };
};
